import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import BowenTherapy from './pages/BowenTherapy';
import Treatment from './pages/Treatment';
import About from './pages/About';
import Prices from './pages/Prices';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-brand-beige text-brand-neutral-dark antialiased selection:bg-brand-sage-medium/30 selection:text-brand-neutral-dark">
        {/* Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bowen-terapi" element={<BowenTherapy />} />
            <Route path="/behandlingen" element={<Treatment />} />
            <Route path="/om-stausbroe" element={<About />} />
            <Route path="/priser" element={<Prices />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
